import { render, staticRenderFns } from "./publicAccumulationFundBill.vue?vue&type=template&id=4c869fc6"
import script from "./publicAccumulationFundBill.vue?vue&type=script&lang=js"
export * from "./publicAccumulationFundBill.vue?vue&type=script&lang=js"
import style0 from "./publicAccumulationFundBill.vue?vue&type=style&index=0&id=4c869fc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports